export default "__VITE_ASSET__BbiifYvB__"